import { changeModalVisibility, setRecommendationToEdit } from '../../../store/recommendationSlice';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import Button from '../../BaseComponents/Button';
import RecommendationsModal from './RecommendationsModal';
import ViewRecommendationModal from './RecommendationsModal/ViewRecommendationModal';
import DeleteRecommendation from './RecommendationsModal/DeleteRecommendationModal';
import RecommendationsTableMedicalLibrary from './RecommendationsTable';
import { RootState } from '../../../store/store';
import { setRecommendationToView } from '../../../store/recommendationSlice';
type Props = {};

const Recommendations = (props: Props) => {
  const dispatch = useDispatch();
  const { isAddRecommendationModalOpened, isDeleteRecommendationModalOpened, recommendationToView } = useSelector(
    (state: RootState) => state.recommendations
  );
 

  return (
    <div>
      <div className='search-row-container'>
        <div className='search-and-filter-container'>
          <div className='count-container'></div>
        </div>
        <Button
          isSecondary={true}
          text='Add  recommendation'
          onClick={() => {
            dispatch(setRecommendationToEdit(null));
            dispatch(changeModalVisibility(true))
          }}
        />
      </div>
     <RecommendationsTableMedicalLibrary />
     { <RecommendationsModal
        isOpen={isAddRecommendationModalOpened}
        onClose={() => {}}
      />}
      <DeleteRecommendation
        isOpen={isDeleteRecommendationModalOpened}
      />
        <ViewRecommendationModal
        isOpen={recommendationToView !== null}
        onClose={() => {
          dispatch(setRecommendationToView(null));
        }}
      />
    </div>
  );
};

export default Recommendations;
